import React, { Component } from "react";
import {
  loading,
  alert,
  Modal,
  GET,
  POST,
  PUT,
  DELETE,
  profile,
  t,
  currentLang,
  ActionIconButton,
  ACTION_ICONS,
} from "./CustomComponent.js";
import { hasPermission, typeName } from "../utils/timeTracking.js";

const ACTION_BLUE = "#2A55E5";

const emptyForm = () => ({
  uid: "",
  code: "",
  name_th: "",
  name_en: "",
  note_required: false,
  is_active: "Active",
  department_uids: [],
});

// แท็บ "ประเภท Activity" ในหน้าตั้งค่าคำขอบริการ (เดิมเป็นหน้า /ad/activity-types) - master ที่ช่างเลือกตอนบันทึก Activity โครงการในแอป
//   GET/POST admin/activity-types, GET/PUT/DELETE admin/activity-types/:uid (รับ department_uids[] - ว่าง = ทุกแผนก)
//   PUT admin/activity-types/reorder {uids:[...]}  เรียงลำดับ (ลำดับในตาราง = ลำดับใน Drop-down บนแอป)
//   in_use / usage_count: ประเภทที่เคยถูกใช้ลบไม่ได้ ต้องปิดใช้งานแทน (ถ้า backend ยังไม่ส่ง in_use = ถือว่ายังลบได้ตามเดิม)
export default class ActivityTypeSettings extends Component {
  constructor(props) {
    super(props);
    // backend คุมด้วยประเภทผู้ใช้ (checkSystemSettingAccess: super_user / it_admin) ไม่ดู role
    // หน้าบทบาทไม่มีช่องให้ติ๊ก activity_type.* จึงต้องให้ประเภทผู้ใช้ระบบผ่านเหมือน backend ไม่งั้น it_admin ไม่เห็นปุ่ม
    const systemType = (global.SYSTEM_SETTINGS_USER_TYPES || []).includes(profile?.user_type);
    this.can = {
      create: systemType || hasPermission(profile, "activity_type.create"),
      update: systemType || hasPermission(profile, "activity_type.update"),
      delete: systemType || hasPermission(profile, "activity_type.delete"),
    };
    this.state = {
      filter_search: "",
      filter_status: "",
      data: [],
      page: 1,
      data_departments: [],
      drag_uid: null,
      drag_over_uid: null,
      preview_dept_uid: "",

      modal: false,
      form: emptyForm(),
    };
  }

  async componentDidMount() {
    loading(false);
    const dept = await GET("admin/departments", { page_size: 1000, page: 0, data_search: "" });
    if (dept?.status && Array.isArray(dept.data)) this.setState({ data_departments: dept.data });
    this.Get();
  }

  Get = async () => {
    loading(true);
    const result = await GET("admin/activity-types", { page_size: 1000, page: 0 });
    const rows = result?.status && Array.isArray(result.data) ? result.data : [];
    this.setState({ data: this.sortBySequence(rows) });
    loading(false);
  };

  // backend คืนตามลำดับอยู่แล้ว เรียงซ้ำกันกรณีไม่มี sequence (คงลำดับเดิม)
  sortBySequence = (rows) =>
    rows.every((r) => r.sequence !== undefined && r.sequence !== null)
      ? [...rows].sort((a, b) => Number(a.sequence) - Number(b.sequence))
      : rows;

  isInUse = (item) => item.in_use === true;

  deptUids = (item) => item.department_uids || (item.departments || []).map((d) => d.uid).filter(Boolean);

  // ว่าง = ใช้ได้ทุกแผนก
  departmentLabel = (item) =>
    item.departments?.length ? item.departments.map((d) => d.name).join(", ") : t("at_all_departments");

  filteredData = () => {
    const { data, filter_search, filter_status } = this.state;
    const q = filter_search.trim().toLowerCase();
    return data.filter((e) => {
      if (filter_status === "Active" && !e.is_active) return false;
      if (filter_status === "Inactive" && e.is_active) return false;
      if (!q) return true;
      return [e.code, e.name_th, e.name_en].some((v) => String(v || "").toLowerCase().includes(q));
    });
  };

  OpenCreate = () => this.setState({ modal: true, form: emptyForm() });

  OpenEdit = async (item) => {
    // ดึงรายตัวเพื่อให้ได้แผนกที่ผูกไว้ครบ (รายการอาจไม่ส่งมา)
    loading(true);
    const result = await GET("admin/activity-types/" + item.uid);
    loading(false);
    const row = result?.status && result.data ? result.data : item;
    this.setState({
      modal: true,
      form: {
        uid: row.uid,
        code: row.code || "",
        name_th: row.name_th || "",
        name_en: row.name_en || "",
        note_required: !!row.note_required,
        is_active: row.is_active === false ? "Inactive" : "Active",
        department_uids: row.department_uids || [],
      },
    });
  };

  SetForm = (patch) => this.setState((prev) => ({ form: { ...prev.form, ...patch } }));

  ToggleDepartment = (uid) => {
    const { department_uids } = this.state.form;
    this.SetForm({
      department_uids: department_uids.includes(uid) ? department_uids.filter((u) => u !== uid) : [...department_uids, uid],
    });
  };

  ToggleAllDepartments = () => {
    const all = this.state.data_departments.map((d) => d.uid);
    const selected = this.state.form.department_uids;
    this.SetForm({ department_uids: all.length && all.every((u) => selected.includes(u)) ? [] : all });
  };

  Save = async () => {
    const { uid, code, name_th, name_en, note_required, is_active, department_uids } = this.state.form;
    if (!code.trim()) {
      alert("", "warning", t("warning"), t("at_validate_code"));
      return;
    }
    if (!name_th.trim()) {
      alert("", "warning", t("warning"), t("at_validate_name_th"));
      return;
    }
    if (!(await alert("", "info", t("confirm"), t("confirm_submission"), t("confirm"), t("cancel")))) return;

    loading(true);
    const body = {
      code: code.trim(),
      name_th: name_th.trim(),
      name_en: name_en.trim(),
      note_required,
      is_active: is_active === "Active",
      department_uids,
    };
    const result = uid ? await PUT("admin/activity-types/" + uid, body) : await POST("admin/activity-types", body);

    if (result?.status === true) {
      this.setState({ modal: false });
      alert("", "success", t("success"), t("save_success"));
      await this.Get();
    } else {
      alert("", "warning", t("warning"), result?.message || "An error occurred.");
    }
    loading(false);
  };

  Delete = async (item) => {
    if (!(await alert("", "warning", t("delete_item"), t("delete_desc"), t("confirm"), t("cancel")))) return;
    loading(true);
    const result = await DELETE("admin/activity-types/" + item.uid, null);
    if (result?.status) {
      alert("", "success", t("success"), t("delete_success"));
      await this.Get();
    } else {
      alert("", "warning", t("warning"), result?.message || "An error occurred.");
    }
    loading(false);
  };

  // ประเภทที่เคยใช้แล้วลบไม่ได้ - ปิดใช้งานแทน (PUT ต้องส่งครบ จึงดึงรายตัวก่อนเพื่อได้แผนกครบ)
  Deactivate = async (item) => {
    if (!(await alert("", "warning", t("at_deactivate"), t("at_deactivate_confirm"), t("confirm"), t("cancel")))) return;
    loading(true);
    const detail = await GET("admin/activity-types/" + item.uid);
    const row = detail?.status && detail.data ? detail.data : item;
    const result = await PUT("admin/activity-types/" + item.uid, {
      code: row.code,
      name_th: row.name_th,
      name_en: row.name_en || "",
      note_required: !!row.note_required,
      is_active: false,
      department_uids: row.department_uids || this.deptUids(row),
    });
    if (result?.status === true) {
      alert("", "success", t("success"), t("at_deactivate_success"));
      await this.Get();
    } else {
      alert("", "warning", t("warning"), result?.message || "An error occurred.");
    }
    loading(false);
  };

  // เรียงลำดับด้วยการลากแถว (ใช้ได้เมื่อไม่ได้กรอง เพราะต้องส่งลำดับของทั้งรายการ)
  canDrag = () => this.can.update && !this.state.filter_search.trim() && !this.state.filter_status;

  HandleDrop = async (dropUid) => {
    const { drag_uid, data } = this.state;
    this.setState({ drag_uid: null, drag_over_uid: null });
    if (!drag_uid || drag_uid === dropUid) return;
    const from = data.findIndex((e) => e.uid === drag_uid);
    const to = data.findIndex((e) => e.uid === dropUid);
    if (from < 0 || to < 0) return;

    const next = [...data];
    const [moved] = next.splice(from, 1);
    next.splice(to, 0, moved);
    this.setState({ data: next.map((e, i) => ({ ...e, sequence: i + 1 })) });

    loading(true);
    const result = await PUT("admin/activity-types/reorder", { uids: next.map((e) => e.uid) });
    if (result?.status !== true) {
      alert("", "warning", t("warning"), result?.message || t("at_reorder_failed"));
      await this.Get(); // คืนลำดับจริงจาก server
    }
    loading(false);
  };

  renderRows(rows) {
    const draggable = this.canDrag();
    const { drag_uid, drag_over_uid } = this.state;
    if (!rows.length) {
      return (
        <tr>
          <td colSpan="8" className="text-center text-secondary py-5">{t("no_data")}</td>
        </tr>
      );
    }
    return rows.map((item) => {
      const inUse = this.isInUse(item);
      const isOver = draggable && drag_over_uid === item.uid && drag_uid && drag_uid !== item.uid;
      return (
        <tr
          key={item.uid}
          className="border-bottom border-light bg-white"
          draggable={draggable}
          onDragStart={() => draggable && this.setState({ drag_uid: item.uid, drag_over_uid: item.uid })}
          onDragOver={(e) => {
            if (!draggable || !drag_uid) return;
            e.preventDefault();
            if (drag_over_uid !== item.uid) this.setState({ drag_over_uid: item.uid });
          }}
          onDrop={(e) => {
            e.preventDefault();
            this.HandleDrop(item.uid);
          }}
          onDragEnd={() => this.setState({ drag_uid: null, drag_over_uid: null })}
          style={{ opacity: drag_uid === item.uid ? 0.5 : 1, outline: isOver ? `2px dashed ${ACTION_BLUE}` : "none", outlineOffset: -2 }}
        >
          <td className="text-center text-secondary" style={{ width: 36, cursor: draggable ? "grab" : "default" }} title={draggable ? t("at_drag") : ""}>
            {draggable ? <span className="icon">{"\uf58e"}</span> : null}
          </td>
          <td className="text-14 fw-semibold text-nowrap">{item.code || "-"}</td>
          <td className="text-14">
            {item.name_th || "-"}
            {item.name_en ? <div className="text-12 text-secondary">{item.name_en}</div> : null}
          </td>
          <td className="text-center">
            {item.note_required ? (
              <span className="text-12 fw-bold text-warning bg-warning-light px-2 py-1 rounded-pill">{t("at_note_required_yes")}</span>
            ) : (
              <span className="text-secondary text-12">-</span>
            )}
          </td>
          <td className="text-14" style={{ maxWidth: 240 }}>{this.departmentLabel(item)}</td>
          <td className="text-center">
            {item.in_use === undefined ? (
              <span className="text-secondary text-12">-</span>
            ) : inUse ? (
              <span className="text-12 fw-bold text-primary px-2 py-1 rounded-pill bg-light border" title={t("at_in_use_count").replace("{n}", item.usage_count ?? "")}>
                {t("at_in_use")}{item.usage_count ? ` (${item.usage_count})` : ""}
              </span>
            ) : (
              <span className="text-secondary text-12">{t("at_unused")}</span>
            )}
          </td>
          <td className="text-center">
            <span className={`text-12 fw-bold px-2 py-1 rounded-pill ${item.is_active ? "text-success bg-success-light" : "text-secondary bg-light border"}`}>
              {item.is_active ? t("active") : t("inactive")}
            </span>
          </td>
          <td className="text-center">
            <div className="d-flex align-items-center gap-2 justify-content-center">
              {this.can.update ? (
                <ActionIconButton label={t("edit")} icon={ACTION_ICONS.edit} variant="warning" onClick={() => this.OpenEdit(item)} />
              ) : null}
              {this.can.delete && !inUse ? (
                <ActionIconButton label={t("delete")} icon={ACTION_ICONS.delete} variant="danger" onClick={() => this.Delete(item)} />
              ) : null}
              {this.can.update && inUse && item.is_active ? (
                <button type="button" className="btn btn-white border btn-sm text-secondary rounded-3 fw-bold" onClick={() => this.Deactivate(item)}>
                  {t("at_deactivate")}
                </button>
              ) : null}
            </div>
          </td>
        </tr>
      );
    });
  }

  // ตัวอย่าง Drop-down บนแอป - เฉพาะประเภทที่เปิดใช้งาน และผูกกับแผนกที่เลือก (ว่าง = ทุกแผนก)
  renderPreview() {
    const { data, data_departments, preview_dept_uid } = this.state;
    const lang = currentLang();
    const options = data.filter((e) => {
      if (!e.is_active) return false;
      const uids = this.deptUids(e);
      return !preview_dept_uid || !uids.length || uids.includes(preview_dept_uid);
    });
    return (
      <div className="bg-white rounded-4 shadow-sm p-4">
        <h6 className="fw-bold text-dark mb-3">{t("at_preview_title")}</h6>
        <label className="form-label text-12 text-secondary mb-1">{t("at_preview_dept")}</label>
        <select className="form-select mb-3" value={preview_dept_uid} onChange={(e) => this.setState({ preview_dept_uid: e.target.value })}>
          <option value="">{t("at_all_departments")}</option>
          {data_departments.map((d) => (
            <option key={d.uid} value={d.uid}>{[d.department_code, d.name].filter(Boolean).join(" - ")}</option>
          ))}
        </select>
        <div className="border rounded-3 overflow-hidden">
          <div className="px-3 py-2 text-secondary text-14 bg-light border-bottom">{t("at_preview_placeholder")}</div>
          {options.length ? (
            options.map((e) => (
              <div key={e.uid} className="px-3 py-2 text-14 border-bottom d-flex justify-content-between align-items-center gap-2">
                <span>{typeName(e, lang)}</span>
                {e.note_required ? <span className="text-12 text-warning fw-bold">{t("at_preview_note_required")}</span> : null}
              </div>
            ))
          ) : (
            <div className="px-3 py-3 text-14 text-secondary">{t("at_preview_empty")}</div>
          )}
        </div>
      </div>
    );
  }

  render() {
    const { filter_search, filter_status, modal, form, data_departments } = this.state;
    const rows = this.filteredData();
    const allSelected = data_departments.length > 0 && data_departments.every((d) => form.department_uids.includes(d.uid));

    return (
      <div>
        <div className="d-flex flex-wrap justify-content-between align-items-center mb-3 gap-3">
          <div className="text-secondary text-14">{t("at_desc")}</div>
          {this.can.create ? (
            <button
              className="btn btn-primary px-3 py-2 fw-bold rounded-3 d-flex align-items-center text-white"
              style={{ backgroundColor: ACTION_BLUE, borderColor: ACTION_BLUE }}
              onClick={this.OpenCreate}
            >
              <span className="icon me-2">{""}</span> {t("at_add")}
            </button>
          ) : null}
        </div>

        <div className="row g-4">
          <div className="col-xl-8">
            <div className="bg-white rounded-4 shadow-sm p-4 mb-3">
              <div className="row g-3 align-items-end">
                <div className="col-md-7">
                  <label className="form-label text-12 text-secondary mb-1">{t("search")}</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder={t("at_search_placeholder")}
                    value={filter_search}
                    onChange={(e) => this.setState({ filter_search: e.target.value })}
                  />
                </div>
                <div className="col-md-5">
                  <label className="form-label text-12 text-secondary mb-1">{t("status")}</label>
                  <select className="form-select" value={filter_status} onChange={(e) => this.setState({ filter_status: e.target.value })}>
                    <option value="">{t("all")}</option>
                    <option value="Active">{t("active")}</option>
                    <option value="Inactive">{t("inactive")}</option>
                  </select>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-4 shadow-sm mb-2 overflow-hidden">
              <div className="table-responsive">
                <table className="table table-hover align-middle mb-0" style={{ minWidth: "900px" }}>
                  <thead>
                    <tr className="text-dark fw-bold text-12 border-bottom border-light">
                      <th className="py-3 border-0" />
                      <th className="py-3 border-0">{t("code")}</th>
                      <th className="py-3 border-0">{t("at_name_th")}</th>
                      <th className="py-3 border-0 text-center">{t("at_note_required")}</th>
                      <th className="py-3 border-0">{t("department")}</th>
                      <th className="py-3 border-0 text-center">{t("at_col_usage")}</th>
                      <th className="py-3 border-0 text-center">{t("status")}</th>
                      <th className="py-3 border-0 text-center">{t("actions")}</th>
                    </tr>
                  </thead>
                  <tbody>{this.renderRows(rows)}</tbody>
                </table>
              </div>
            </div>
            <div className="text-12 text-secondary">{this.can.update ? `${t("at_drag_hint")} · ` : ""}{t("at_delete_hint")}</div>
          </div>

          <div className="col-xl-4">{this.renderPreview()}</div>
        </div>

        {/* MODAL: CREATE / EDIT */}
        <Modal show={modal} onHide={() => this.setState({ modal: false })} centered contentClassName="border-0 rounded-4 shadow-lg">
          <Modal.Header className="border-bottom border-light px-4 py-3 bg-white" closeButton>
            <h5 className="fw-bold mb-0 text-dark">{form.uid ? t("at_modal_edit") : t("at_modal_create")}</h5>
          </Modal.Header>
          <Modal.Body className="p-4 bg-white">
            <div className="row g-3">
              <div className="col-12">
                <label className="form-label text-14 text-dark mb-2">{t("code")} <span className="text-danger">*</span></label>
                <input type="text" className="form-control py-2" value={form.code} onChange={(e) => this.SetForm({ code: e.target.value })} />
              </div>
              <div className="col-md-6">
                <label className="form-label text-14 text-dark mb-2">{t("at_name_th")} <span className="text-danger">*</span></label>
                <input type="text" className="form-control py-2" value={form.name_th} onChange={(e) => this.SetForm({ name_th: e.target.value })} />
              </div>
              <div className="col-md-6">
                <label className="form-label text-14 text-dark mb-2">{t("at_name_en")}</label>
                <input type="text" className="form-control py-2" value={form.name_en} onChange={(e) => this.SetForm({ name_en: e.target.value })} />
              </div>

              <div className="col-12">
                <div className="form-check d-flex align-items-center gap-2">
                  <input
                    className="form-check-input mt-0 pointer"
                    type="checkbox"
                    id="atNoteRequired"
                    checked={form.note_required}
                    onChange={(e) => this.SetForm({ note_required: e.target.checked })}
                  />
                  <label className="form-check-label text-dark text-14 pointer" htmlFor="atNoteRequired">{t("at_note_required_label")}</label>
                </div>
              </div>

              <div className="col-12">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <label className="form-label text-14 text-dark mb-0">{t("department")}</label>
                  <button type="button" className="btn btn-link btn-sm p-0" onClick={this.ToggleAllDepartments}>
                    {allSelected ? t("at_clear_all") : t("at_select_all")}
                  </button>
                </div>
                <div className="border rounded-3 p-2" style={{ maxHeight: 200, overflowY: "auto" }}>
                  {data_departments.map((d) => (
                    <div key={d.uid} className="form-check d-flex align-items-center gap-2 py-1">
                      <input
                        className="form-check-input mt-0 pointer"
                        type="checkbox"
                        id={`atDept-${d.uid}`}
                        checked={form.department_uids.includes(d.uid)}
                        onChange={() => this.ToggleDepartment(d.uid)}
                      />
                      <label className="form-check-label text-dark text-14 pointer" htmlFor={`atDept-${d.uid}`}>
                        {[d.department_code, d.name].filter(Boolean).join(" - ")}
                      </label>
                    </div>
                  ))}
                  {!data_departments.length ? <div className="text-secondary text-14 p-1">{t("no_data")}</div> : null}
                </div>
                <div className="text-12 text-secondary mt-1">{t("at_department_hint")}</div>
              </div>

              <div className="col-12 border-top pt-3">
                <div className="d-flex gap-4">
                  {["Active", "Inactive"].map((v) => (
                    <div key={v} className="form-check d-flex align-items-center gap-2">
                      <input
                        className="form-check-input mt-0 pointer"
                        type="radio"
                        name="atStatus"
                        id={`atStatus-${v}`}
                        checked={form.is_active === v}
                        onChange={() => this.SetForm({ is_active: v })}
                      />
                      <label className="form-check-label text-dark text-14 pointer" htmlFor={`atStatus-${v}`}>
                        {t(v === "Active" ? "active" : "inactive")}
                      </label>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="border-top border-light px-4 py-3 bg-white d-flex justify-content-end gap-2">
            <button className="btn btn-white border px-4 py-2 text-dark rounded-3 fw-bold" onClick={() => this.setState({ modal: false })}>
              {t("cancel")}
            </button>
            <button
              className="btn btn-primary px-4 py-2 d-flex align-items-center rounded-3 fw-bold text-white shadow-sm"
              style={{ backgroundColor: ACTION_BLUE, borderColor: ACTION_BLUE }}
              onClick={this.Save}
            >
              <span className="icon me-2">{""}</span> {t("save")}
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
